export default [
	{
		title: "Preparacion",
		icon: "PlayCircleIconIcon",
		route: "preparacion-sr-actives",
		roles: [1, 5, 7],
	},
];
